import { z } from 'zod';

export const proofNoteSchema = z.object({
  message: z.string().trim().min(1, '쪽지 내용을 입력해주세요.'),
  attachment: z.custom<FileList>().optional(),
});

export type ProofNoteSchema = z.infer<typeof proofNoteSchema>;

export const proofRevisionSchema = z.object({
  items: z
    .array(z.enum(['TEXT', 'IMAGE', 'COLOR', 'LAYOUT', 'SIZE', 'ETC']))
    .min(1, '수정할 항목을 하나 이상 선택해주세요.'),
  message: z.string().trim().min(10, '수정할 내용을 10자 이상 구체적으로 적어주세요.'),
  attachment: z.custom<FileList>().optional(),
  agreeExtraFee: z.boolean().optional(),
});

export type ProofRevisionSchema = z.infer<typeof proofRevisionSchema>;
